import React, { useContext, useEffect, useRef, useState } from 'react';
// import ScrollWrapper from '@/components/ScrollWrapper/ScrollWrapper';
import withAlphaMiddleware from '@/hocs/withAlphaMiddleware';
import Posts from './Posts';
import UserInfo from './UserInfo';
import ProfilesProvider, { useProfiles } from './provider';
import s from './styles.module.scss';

const Profiles = () => {
  const {
    isProfileLoading,
    isTokenHoldingLoading,
    setIsProfileLoading,
    fetchData,
  } = useProfiles();
  const [statusPublicPost, setStatusPublicPost] = useState<boolean | null>(
    null
  );
  const hasIncrementedPageRef = useRef(true);
  const refParentScroll = useRef<any>();
  const [currentOffset, setCurrentOffset] = useState(0);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  const refreshNewData = async () => {
    try {
      setIsProfileLoading(true);
      fetchData();
    } catch (error) {}
  };

  const parentScroll = (e: any) => {
    const container = e.target;
    const isScrolledToBottom =
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - container.scrollHeight / 4;
    setIsScrolledToBottom(isScrolledToBottom);
    setCurrentOffset(container?.scrollTop);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.profiles}>
        <div className={s.posts}>
          <Posts
            setStatusPublicPost={setStatusPublicPost}
            isScrolledToBottom={isScrolledToBottom}
          />
        </div>
      </div>
    </div>
  );
};

export default withAlphaMiddleware(
  React.memo(() => {
    return (
      <ProfilesProvider>
        <Profiles />
      </ProfilesProvider>
    );
  })
);
